/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelattachdrop2Inputs */

const en_channelattachdrop2 = /** @type {(inputs: Channelattachdrop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

const de_channelattachdrop2 = /** @type {(inputs: Channelattachdrop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

/**
* | output |
* | --- |
* | "Drop" |
*
* @param {Channelattachdrop2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelattachdrop2 = /** @type {((inputs?: Channelattachdrop2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelattachdrop2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelattachdrop2(inputs)
	return de_channelattachdrop2(inputs)
});
export { channelattachdrop2 as "channelAttachDrop" }